// extracted by mini-css-extract-plugin
module.exports = {"rating":"fm-z","numberOfStars":"gm-z","count":"hm-z"};